import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { ValidateDeleteBeneficiaryOTP as BENE_VERIFY } from 'Components/Api/ClareInfoTechDMTAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Grid, Paper, Button, Hidden } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useLocation } from 'react-router-dom';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const BeneDeleteVerify = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const ActiveDMTName = location?.state?.ActiveDMTName;
    const BeneData = location?.state?.BeneData;
    const OTPReference = location?.state?.OTPReference;

    const [formObject, setFormObject] = useState({
        Mobile: BeneData[9],
        Name: BeneData[1],
        BankName: BeneData[2],
        AccountNo: BeneData[3],
        IFSC: BeneData[4],
        OTP: '',
        BeneficiaryID: BeneData[0],
        OTPReference: OTPReference,
        DMTName: ActiveDMTName
    });

    const submitHandle = async (values, { setSubmitting, resetForm }) => {
        var request = {
            BeneficiaryID: values.BeneficiaryID,
            OTPReference: values.OTPReference,
            OTP: values.OTP,
            DMTName: ActiveDMTName,
            SenderID: values.Mobile
        };

        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await BENE_VERIFY(requestObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        setSeverity('success');
        setIsError(true);

        var param = {
            Mobile: values.Mobile,
            DMTName: ActiveDMTName
        };
        history.push('/CIT_DMTSenderSearch', param);
    };

    const FormValidationSchema = Yup.object({
        OTP: Yup.string().required(PLEASE_PROVIDE_VALID + 'OTP'),
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),

        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Delete Beneficiary OTP Verify
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Sender Mobile"
                                                name="Mobile"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Sender Mobile"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Bene Name"
                                                name="Name"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Bene Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Bank"
                                                name="BankName"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Bank"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Account No."
                                                name="AccountNo"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Account No."
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="IFSC"
                                                name="IFSC"
                                                type="text"
                                                readOnly={true}
                                                placeholder="IFSC"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="OTP"
                                                name="OTP"
                                                length={6}
                                                type="text"
                                                placeholder="OTP"
                                            />

                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="BeneficiaryID"
                                                    name="BeneficiaryID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="BeneficiaryID"
                                                />
                                            </Hidden>
                                            {/* <Hidden xsUp>
                                                <MaterialTextField
                                                    label="OTPReference"
                                                    name="OTPReference"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="OTPReference"
                                                />
                                            </Hidden> */}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Verify"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            onClick={(e) => {
                                                setFieldValue(
                                                    'isSecondSubmit',
                                                    false
                                                );
                                                handleSubmit(e);
                                            }}
                                            disabled={loading}
                                        >
                                            Verify
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </CustomContainer>
    );
};
